import React, { useState, useContext, useEffect, useRef } from 'react'
import { Selected } from '../../../context/context'
import { getFirestore } from '../../../firebase/firebase'
import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation } from 'swiper'
import 'swiper/swiper.scss';
import './custom.css'
import 'swiper/components/navigation/navigation.scss'
import {
    ProductsContainer, 
    ProductsTitle,
    ProductsInner,
    ProductsListViewer,
    Inner, 
    SlideImage,
    ProductName,
    Skeleton,
} from './Elements'
import { productsMotion, titleMotion } from './Motion'
import SwiperButtons from './SwiperButtons'

SwiperCore.use([Navigation]);

const Producto = () => {

    const db = getFirestore()
    const [ prendas, setPrendas ] = useState([])
    const [ selected, setSelected ] = useContext(Selected)
    const skeletons = [0, 1, 2, 3, 4]
    const swiperRef = useRef()

    useEffect(() => {

        const unsubscribe = () => {
                db.collection('prendas').where("tecnica", "array-contains", selected.tecnica).get()
                .then(prendas => {
                    let array = []
                    prendas.forEach(prenda => {
                        array.push(prenda.data())
                    })
                    
                    setPrendas(array)
            
                })
                .catch(err => console.log(err))
        }

        return unsubscribe()
        
    }, [])

    const handleClick = (title, img, colores, precio) => {
        setSelected({
            ...selected,
            producto: title,
            imagen: img,
            coloresDisponibles: colores,
            total: precio,
            precioUnidad: precio
        })
    }

    return(
        <ProductsContainer>
            <>
                <ProductsTitle
                variants={titleMotion}
                initial="initial"
                animate="animate"
                exit="exit"
                >
                    Ahora elegí tu prenda
                </ProductsTitle>
                <ProductsInner
                variants={productsMotion}
                initial="initial"
                animate="animate"
                exit="exit"
                >
                    <ProductsListViewer>
                        <Swiper
                            ref={swiperRef}
                            slidesPerView='auto'
                            style={{'height': '20rem'}}
                        >
                            {
                                prendas.length !== 0 ?
                                <>
                                {
                                    prendas.map(prenda => {
                                        return(
                                                <SwiperSlide 
                                                key={prenda.title}
                                                className='swiper-slide-container'
                                                >
                                                    <Inner
                                                    onClick={() => {
                                                        handleClick(
                                                            prenda.title, 
                                                            prenda.img, 
                                                            prenda.colores, 
                                                            prenda.price
                                                        )
                                                    }}
                                                    to='/caracteristicas'
                                                    >
                                                        <SlideImage src={prenda.img} alt={prenda.title}/>
                                                        <ProductName>{prenda.title}</ProductName>
                                                    </Inner>
                                                </SwiperSlide>
                                        )
                                    }) 
                                }
                                </> :
                                <>
                                {
                                    skeletons.map(skeleton => {
                                        return(
                                            <SwiperSlide 
                                            key={skeleton}
                                            className='swiper-slide-container'
                                            >
                                                <Skeleton />
                                            </SwiperSlide>
                                        )
                                    })
                                }
                                </>
                                
                            }
                        </Swiper>
                        <SwiperButtons swiperRef={swiperRef} />
                    </ProductsListViewer>
                </ProductsInner>
            </>
        </ProductsContainer>
    )
}

export default Producto